module.exports = __webpack_public_path__ + "static/media/wechat.ef29dea0.jpg";